<template>
  <div id="article__container">
    <div class="loading" v-if="isLoading">
      Loading...
    </div>
    <div v-bind:class="{'hide': isLoading}" class="article__view" :id="$route.params.article">
      <div class="article__hero-image" :style="{ backgroundColor: coverImageBackgroundColor }">
        <h1 class="article__heading" v-html="title"></h1>
        <img :src="heroImage" :alt="title" :class="[ coverImageStyle ? 'type--cover' : 'type--contain' ]" v-if="coverPhotoType" />
        <video loop playsinline v-if="!coverPhotoType">
          <source :src="data.coverPhoto" type="video/mp4">
          </video>
        </div>
        <div class="article__project-link" v-bind:class="{ 'override-background' : this.mobile && this.isVisible === null }">
          <ul class="project__sections" v-if="desktop">
            <li
              v-for="(section, index) in sectionName"
              :key="`project-sections-${index}`"
              v-on:click="goToSection(sectionID[index])"
            >
              {{ section }}
            </li>
          </ul>
          <div class="project__sections" v-if="tablet">
            <div class="sections__title">Sections:</div>
            <select name="sections" @change="goToSectionMobile($event)">
              <option
                v-for="(section, index) in sectionID"
                :key="`project-sections-tablet-${index}`"
                :value="section"
              >
                {{ sectionName[index] }}
              </option>
            </select>
          </div>
          <a :href="projectUrl" target="_blank" v-if="isVisible">{{ projectUrl }}</a>
        </div>
        <div class="article__content pp-grid-container pp-grid-container--blog" v-bind:class="{ 'menu-fix': isFixed }">
          <div class="article__content-text" v-html="text"></div>
        </div>
      </div>
  </div>
</template>

<script>
/* eslint-disable consistent-return */
/* eslint-disable no-console */
const marked = require('marked');

export default {
  name: 'article',
  props: ['mobile', 'tablet', 'desktop', 'content'],
  data() {
    return {
      isActive: false,
      isLoading: true,
      isFixed: false,
      isVisible: this.content[0].projectUrl,
      title: this.content[0].title,
      pageBackground: this.content[0].pageBackground,
      headingColor: this.content[0].headingColor,
      heroImage: this.content[0].coverPhoto,
      coverPhotoType: this.content[0].coverPhotoType,
      coverImageStyle: this.content[0].coverImageStyle,
      coverImageBackgroundColor: this.content[0].coverImageBackgroundColor,
      projectUrl: this.content[0].projectUrl,
      text: this.content[0].body,
      sectionName: [],
      sectionID: [],
      selectedSection: '',
    };
  },
  created() {
    this.getId();
    window.scrollTo(0, 0);
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('scroll', this.handleScroll);
  },
  watch: {
    $route: 'getId',
  },
  mounted() {
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    this.linkNewWindow();
    this.imageCaption();
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {

  },
  methods: {
    getArticleIndex() {
      const articleTitle = this.$route.params.article;

      for (let i = 0; i < this.content.length; i += 1) {
        if (this.content[i].url === articleTitle) {
          return i;
        } else if (this.content[i].url !== articleTitle
          && i === this.content.length - 1) {
          return false;
        }
      }
    },
    getId() {
      window.scrollTo(0, 0);
      this.isLoading = true;
      this.sectionID = [];
      this.sectionName = [];

      if (this.getArticleIndex() === false) {
        this.$router.push('/404');
      } else {
        const articleId = this.getArticleIndex();

        document.title = `${this.content[articleId].title}`;
        // console.log(document.title);

        this.isVisible = this.content[articleId].projectUrl;
        this.title = this.content[articleId].title;
        this.pageBackground = this.content[articleId].pageBackground;
        this.headingColor = this.content[articleId].headingColor;
        this.heroImage = this.content[articleId].coverPhoto;
        this.coverPhotoType = this.content[articleId].coverPhotoType;
        this.coverImageStyle = this.content[articleId].coverImageStyle;
        this.coverImageBackgroundColor = this.content[articleId].coverImageBackgroundColor;

        if (this.isVisible) {
          // this.projectUrl = this.content[articleId].projectUrl.substring(7);
          this.projectUrl = this.content[articleId].projectUrl;
        }
        this.text = marked(this.content[articleId].body);

        this.linkNewWindow();
        this.imageCaption();

        setTimeout(() => {
          this.isLoading = false;
          document.querySelector('.article__heading').style.color = this.headingColor;
        }, 200);

        // update page background color
        document.documentElement.style.backgroundColor = this.pageBackground;

        setTimeout(() => {
          this.getSections();
        }, 500);
      }
    },
    getSections() {
      const sections = document.querySelectorAll('.article__content-text h3');
      const menu = document.querySelectorAll('.article__project-link')[0];

      this.sectionID = [];
      this.sectionName = [];

      menu.style.backgroundColor = this.pageBackground;

      for (let i = 0; i < sections.length; i += 1) {
        const id = sections[i].getAttribute('id');
        const name = sections[i].getAttribute('id').replace(/[^A-Z0-9]+/ig, ' ');
        this.sectionName.push(name);
        this.sectionID.push(id);
      }
    },
    goToSection(id) {
      this.$SmoothScroll(document.getElementById(id), 500);
    },
    goToSectionMobile(event) {
      this.selectedSection = event.target.value;
      this.$SmoothScroll(document.getElementById(this.selectedSection), 500);
    },
    fixMenu() {
      const menu = document.querySelectorAll('.article__project-link')[0];
      const heroImage = document.querySelectorAll('.article__hero-image')[0];
      const trigger = heroImage.offsetHeight + heroImage.offsetTop;

      if (window.scrollY > trigger) {
        menu.classList.add('fixed');
        this.isFixed = true;
      } else if (window.scrollY < trigger) {
        menu.classList.remove('fixed');
        this.isFixed = false;
      }
      // console.log(window.scrollY, this.menuOffset);
    },
    highlightSectionMenu() {
      const sections = document.querySelectorAll('.article__content-text h3');
      const sectionMenu = document.querySelectorAll('.project__sections li');
      const heroImage = document.querySelectorAll('.article__hero-image')[0];
      const heroImageOffset = heroImage.offsetHeight + heroImage.offsetTop;

      for (let i = 0; i < sections.length; i += 1) {
        if (i + 1 !== sections.length) {
          if (sections[i].offsetTop + heroImageOffset < window.scrollY
            && window.scrollY < sections[i + 1].offsetTop + heroImageOffset) {
            sectionMenu[i].classList.add('active');
          } else {
            sectionMenu[i].classList.remove('active');
          }
        }

        if (i + 1 === sections.length) {
          if (sections[i].offsetTop + heroImageOffset < window.scrollY) {
            sectionMenu[i].classList.add('active');
          } else {
            sectionMenu[i].classList.remove('active');
          }
        }
        // console.log(window.scrollY, sections[i].offsetTop + heroImageOffset);
      }
    },
    linkNewWindow() {
      setTimeout(() => {
        const links = document.querySelectorAll('.article__content-text a');
        for (let i = 0; i < links.length; i += 1) {
          links[i].setAttribute('target', '_blank');
          // console.log(links[i]);
        }
      }, 2000);
    },
    imageCaption() {
      setTimeout(() => {
        if (document.querySelector('.article__content-text img')) {
          const imageW = document.querySelector('.article__content-text img').offsetWidth;
          const captions = document.querySelectorAll('.article__content-text blockquote');
          // console.log(imageW);
          for (let i = 0; i < captions.length; i += 1) {
            captions[i].style.width = `${imageW} px`;
            // console.log(captions[i]);
          }
        }
      }, 1000);
    },
    handleResize() {
      this.imageCaption();
    },
    handleScroll() {
      this.fixMenu();

      if (this.desktop && !this.isLoading) {
        this.highlightSectionMenu();
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
